export const heroSlides = [
  {
    id: 1,
    title: "2024年度热门国产大片精选",
    description: "汇聚年度最受欢迎国产影片，高清画质畅快观看",
    imageUrl: "https://readdy.ai/api/search-image?query=Cinematic%20film%20scene%20with%20dramatic%20lighting%20and%20warm%20golden%20tones%2C%20abstract%20artistic%20movie%20poster%20style%20with%20rich%20red%20and%20amber%20gradients%2C%20soft%20bokeh%20effects%2C%20elegant%20composition%2C%20cinematic%20atmosphere%2C%20clean%20minimal%20design%20with%20subtle%20texture%2C%20no%20text%20visible&width=1600&height=900&seq=hero-slide-01&orientation=landscape",
    link: "/category/movie",
  },
  {
    id: 2,
    title: "热门电视剧连播不间断",
    description: "追剧首选平台，热门剧集每日更新",
    imageUrl: "https://readdy.ai/api/search-image?query=Warm%20cinematic%20evening%20scene%20with%20soft%20ambient%20lighting%20and%20rich%20amber%20hues%2C%20abstract%20artistic%20television%20series%20concept%2C%20flowing%20geometric%20shapes%20in%20warm%20red%20and%20gold%20tones%2C%20elegant%20movie%20poster%20aesthetic%2C%20minimalist%20composition%20with%20atmospheric%20glow%2C%20no%20text&width=1600&height=900&seq=hero-slide-02&orientation=landscape",
    link: "/category/tv",
  },
  {
    id: 3,
    title: "精彩综艺节目欢乐不断",
    description: "热门综艺、真人秀、访谈节目应有尽有",
    imageUrl: "https://readdy.ai/api/search-image?query=Vibrant%20artistic%20entertainment%20show%20concept%20with%20warm%20coral%20and%20golden%20light%20effects%2C%20dynamic%20abstract%20stage%20atmosphere%2C%20soft%20gradients%20in%20warm%20red%20and%20amber%20tones%2C%20festive%20yet%20elegant%20composition%2C%20clean%20background%20with%20subtle%20dramatic%20lighting%2C%20cinematic%20style%2C%20no%20text&width=1600&height=900&seq=hero-slide-03&orientation=landscape",
    link: "/category/variety",
  },
];

export const categories = [
  { id: "movie", name: "电影", icon: "ri-movie-line", slug: "movie" },
  { id: "tv", name: "电视剧", icon: "ri-tv-line", slug: "tv" },
  { id: "variety", name: "综艺", icon: "ri-live-line", slug: "variety" },
  { id: "anime", name: "动漫", icon: "ri-ancient-gate-line", slug: "anime" },
  { id: "documentary", name: "纪录片", icon: "ri-film-line", slug: "documentary" },
  { id: "short", name: "短视频", icon: "ri-video-line", slug: "short" },
];

export const hotContents = [
  {
    id: 1,
    title: "长安十二时辰",
    category: "电视剧",
    rating: 9.2,
    year: 2024,
    imageUrl: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20city%20at%20night%20with%20lanterns%20and%20warm%20ambient%20light%2C%20cinematic%20film%20poster%20style%2C%20dramatic%20atmosphere%20with%20rich%20red%20and%20golden%20tones%2C%20historical%20drama%20theme%2C%20clean%20minimalist%20composition%2C%20artistic%20movie%20aesthetic&width=600&height=800&seq=hot-01&orientation=portrait",
    slug: "changan-twelve-hours",
    description: "唐朝天宝年间，长安城陷入一场惊天阴谋，死囚张小敬临危受命，要在十二时辰内拯救长安。",
  },
  {
    id: 2,
    title: "流浪地球3",
    category: "电影",
    rating: 8.8,
    year: 2024,
    imageUrl: "https://readdy.ai/api/search-image?query=Futuristic%20space%20scene%20with%20warm%20orange%20and%20golden%20nebula%20glow%2C%20sci-fi%20movie%20poster%20style%2C%20dramatic%20cosmic%20atmosphere%2C%20artistic%20abstract%20composition%20with%20rich%20amber%20hues%2C%20cinematic%20lighting%2C%20clean%20minimal%20design%2C%20no%20text&width=600&height=800&seq=hot-02&orientation=portrait",
    slug: "wandering-earth-3",
    description: "人类面临太阳系毁灭危机，年轻一代挺身而出，展开一场跨越星际的壮丽征程。",
  },
  {
    id: 3,
    title: "乘风破浪的姐姐第五季",
    category: "综艺",
    rating: 8.5,
    year: 2024,
    imageUrl: "https://readdy.ai/api/search-image?query=Elegant%20stage%20performance%20with%20warm%20spotlight%20and%20sparkling%20golden%20effects%2C%20entertainment%20show%20concept%2C%20artistic%20abstract%20composition%20with%20rich%20coral%20and%20amber%20tones%2C%20festive%20atmosphere%2C%20cinematic%20poster%20style%2C%20clean%20background%2C%20no%20text&width=600&height=800&seq=hot-03&orientation=portrait",
    slug: "sisters-season-5",
    description: "30+姐姐们再度集结，用实力和魅力征服舞台，展现女性力量的无限可能。",
  },
  {
    id: 4,
    title: "狂飙",
    category: "电视剧",
    rating: 9.5,
    year: 2023,
    imageUrl: "https://readdy.ai/api/search-image?query=Dramatic%20urban%20night%20scene%20with%20contrasting%20shadows%20and%20warm%20golden%20street%20lights%2C%20crime%20drama%20film%20poster%20style%2C%20intense%20atmosphere%20with%20rich%20amber%20and%20dark%20red%20tones%2C%20artistic%20composition%2C%20cinematic%20aesthetic%2C%20no%20text&width=600&height=800&seq=hot-04&orientation=portrait",
    slug: "the-knockout",
    description: "一线刑警安欣与黑恶势力展开长达二十年的生死较量，正义与邪恶的终极对决。",
  },
  {
    id: 5,
    title: "封神第二部",
    category: "电影",
    rating: 8.7,
    year: 2024,
    imageUrl: "https://readdy.ai/api/search-image?query=Epic%20ancient%20Chinese%20mythological%20scene%20with%20dramatic%20battle%20atmosphere%2C%20warm%20golden%20and%20crimson%20lighting%2C%20fantasy%20film%20poster%20style%2C%20artistic%20abstract%20composition%20with%20rich%20red%20tones%2C%20cinematic%20grandeur%2C%20clean%20design%2C%20no%20text&width=600&height=800&seq=hot-05&orientation=portrait",
    slug: "creation-of-gods-2",
    description: "殷商末年，封神大战全面爆发，姜子牙率领众神与纣王展开终极对决。",
  },
  {
    id: 6,
    title: "大江大河3",
    category: "电视剧",
    rating: 9.0,
    year: 2024,
    imageUrl: "https://readdy.ai/api/search-image?query=Warm%20nostalgic%20Chinese%20countryside%20scene%20with%20soft%20evening%20light%20and%20golden%20fields%2C%20period%20drama%20film%20poster%20style%2C%20artistic%20composition%20with%20rich%20amber%20and%20earthy%20tones%2C%20cinematic%20atmosphere%2C%20clean%20minimalist%20design%2C%20no%20text&width=600&height=800&seq=hot-06&orientation=portrait",
    slug: "like-a-flowing-river-3",
    description: "改革开放浪潮中，三位主人公在不同领域奋斗拼搏，书写属于时代的壮丽篇章。",
  },
  {
    id: 7,
    title: "满江红",
    category: "电影",
    rating: 8.3,
    year: 2023,
    imageUrl: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20courtyard%20at%20dusk%20with%20warm%20lantern%20light%20and%20deep%20shadows%2C%20historical%20mystery%20film%20poster%20style%2C%20dramatic%20atmosphere%20with%20rich%20red%20and%20dark%20amber%20tones%2C%20artistic%20composition%2C%20cinematic%20aesthetic%2C%20no%20text&width=600&height=800&seq=hot-07&orientation=portrait",
    slug: "full-river-red",
    description: "南宋绍兴年间，一桩离奇命案牵出惊天阴谋，小人物们上演了一场惊心动魄的忠义大戏。",
  },
  {
    id: 8,
    title: "向往的生活第八季",
    category: "综艺",
    rating: 8.1,
    year: 2024,
    imageUrl: "https://readdy.ai/api/search-image?query=Peaceful%20countryside%20cottage%20with%20warm%20sunset%20light%20and%20lush%20greenery%2C%20lifestyle%20show%20concept%2C%20artistic%20composition%20with%20rich%20golden%20and%20warm%20green%20tones%2C%20relaxing%20atmosphere%2C%20cinematic%20poster%20style%2C%20clean%20design%2C%20no%20text&width=600&height=800&seq=hot-08&orientation=portrait",
    slug: "back-to-field-8",
    description: "回归田园生活，明星嘉宾们在蘑菇屋自给自足，感受最简单纯粹的快乐。",
  },
];

export const latestContents = [
  {
    id: 101,
    title: "你好，李焕英2",
    category: "电影",
    rating: 8.9,
    year: 2024,
    imageUrl: "https://readdy.ai/api/search-image?query=Warm%20nostalgic%20family%20scene%20with%20soft%20golden%20sunlight%2C%20emotional%20film%20poster%20style%2C%20artistic%20composition%20with%20rich%20amber%20and%20warm%20coral%20tones%2C%20cinematic%20atmosphere%2C%20heartwarming%20aesthetic%2C%20clean%20design%2C%20no%20text&width=600&height=800&seq=latest-01&orientation=portrait",
    slug: "hi-mom-2",
    description: "贾玲再度执导，讲述母女之间跨越时空的温暖故事，笑中带泪。",
  },
  {
    id: 102,
    title: "三体：黑暗森林",
    category: "电视剧",
    rating: 9.3,
    year: 2024,
    imageUrl: "https://readdy.ai/api/search-image?query=Mysterious%20cosmic%20scene%20with%20dark%20space%20and%20warm%20distant%20star%20glow%2C%20sci-fi%20drama%20poster%20style%2C%20artistic%20abstract%20composition%20with%20rich%20dark%20red%20and%20amber%20tones%2C%20atmospheric%20cinematic%20design%2C%20no%20text&width=600&height=800&seq=latest-02&orientation=portrait",
    slug: "three-body-dark-forest",
    description: "面壁计划启动，罗辑与三体文明展开跨越光年的智慧博弈，宇宙法则残酷而美丽。",
  },
  {
    id: 103,
    title: "热辣滚烫",
    category: "电影",
    rating: 7.9,
    year: 2024,
    imageUrl: "https://readdy.ai/api/search-image?query=Vibrant%20boxing%20gym%20scene%20with%20warm%20dramatic%20lighting%20and%20dynamic%20energy%2C%20sports%20drama%20film%20poster%20style%2C%20artistic%20composition%20with%20rich%20coral%20and%20golden%20tones%2C%20motivational%20atmosphere%2C%20cinematic%20aesthetic%2C%20no%20text&width=600&height=800&seq=latest-03&orientation=portrait",
    slug: "yolo",
    description: "乐莹在拳击中找到自我，用汗水与坚持蜕变成更好的自己，燃爆全场。",
  },
  {
    id: 104,
    title: "庆余年2",
    category: "电视剧",
    rating: 8.6,
    year: 2024,
    imageUrl: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20interior%20with%20warm%20candlelight%20and%20luxurious%20details%2C%20historical%20drama%20poster%20style%2C%20artistic%20composition%20with%20rich%20red%20and%20golden%20tones%2C%20elegant%20cinematic%20atmosphere%2C%20clean%20design%2C%20no%20text&width=600&height=800&seq=latest-04&orientation=portrait",
    slug: "joy-of-life-2",
    description: "范闲历经生死重返京都，朝堂之上暗流涌动，江湖之中危机四伏。",
  },
  {
    id: 105,
    title: "哪吒之魔童闹海",
    category: "动漫",
    rating: 9.1,
    year: 2025,
    imageUrl: "https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythological%20scene%20with%20dramatic%20fire%20and%20water%20elements%2C%20animated%20film%20poster%20style%2C%20artistic%20composition%20with%20rich%20crimson%20and%20golden%20tones%2C%20dynamic%20action%20atmosphere%2C%20cinematic%20grandeur%2C%20clean%20design%2C%20no%20text&width=600&height=800&seq=latest-05&orientation=portrait",
    slug: "nezha-2",
    description: "哪吒与敖丙的命运再度交织，一场惊天动地的神魔大战即将拉开序幕。",
  },
  {
    id: 106,
    title: "孤注一掷",
    category: "电影",
    rating: 8.4,
    year: 2023,
    imageUrl: "https://readdy.ai/api/search-image?query=Tense%20urban%20night%20scene%20with%20contrasting%20neon%20warm%20lights%20and%20deep%20shadows%2C%20thriller%20film%20poster%20style%2C%20artistic%20composition%20with%20rich%20amber%20and%20dark%20red%20tones%2C%20suspenseful%20cinematic%20atmosphere%2C%20clean%20design%2C%20no%20text&width=600&height=800&seq=latest-06&orientation=portrait",
    slug: "no-more-bets",
    description: "程序员潘生被高薪诱惑卷入境外诈骗工厂，一场惊心动魄的逃亡就此展开。",
  },
  {
    id: 107,
    title: "繁花",
    category: "电视剧",
    rating: 9.4,
    year: 2024,
    imageUrl: "https://readdy.ai/api/search-image?query=Retro%201990s%20Shanghai%20night%20scene%20with%20warm%20neon%20lights%20and%20elegant%20nostalgia%2C%20period%20drama%20poster%20style%2C%20artistic%20composition%20with%20rich%20golden%20and%20amber%20tones%2C%20cinematic%20atmosphere%2C%20clean%20design%2C%20no%20text&width=600&height=800&seq=latest-07&orientation=portrait",
    slug: "blossoms-shanghai",
    description: "九十年代上海滩，阿宝在商海浮沉中书写传奇，人情冷暖尽在其中。",
  },
  {
    id: 108,
    title: "脱口秀大会第六季",
    category: "综艺",
    rating: 8.0,
    year: 2024,
    imageUrl: "https://readdy.ai/api/search-image?query=Vibrant%20comedy%20stage%20with%20warm%20spotlight%20and%20energetic%20atmosphere%2C%20talk%20show%20concept%2C%20artistic%20composition%20with%20rich%20coral%20and%20golden%20tones%2C%20festive%20yet%20elegant%20style%2C%20cinematic%20poster%20aesthetic%2C%20no%20text&width=600&height=800&seq=latest-08&orientation=portrait",
    slug: "talk-show-6",
    description: "新老脱口秀演员同台竞技，用幽默和智慧点燃观众，笑声与思考并存。",
  },
];

export const articles = [
  {
    id: 1,
    title: "2024年国产电影票房TOP10盘点：哪些影片值得一看",
    category: "电影",
    author: "影视观察员",
    date: "2024-12-15",
    imageUrl: "https://readdy.ai/api/search-image?query=Movie%20theater%20interior%20with%20warm%20ambient%20lighting%20and%20cinematic%20atmosphere%2C%20film%20review%20concept%2C%20artistic%20composition%20with%20rich%20red%20and%20golden%20tones%2C%20elegant%20editorial%20style%2C%20clean%20design%2C%20no%20text&width=800&height=450&seq=article-01&orientation=landscape",
    slug: "2024-chinese-film-box-office-top10",
    summary: "回顾2024年国产电影的辉煌战绩，盘点票房前十名的精彩影片，看看哪些作品真正配得上观众的掌声与票根。",
    content: "2024年是中国电影市场蓬勃发展的一年，多部国产影片不仅在国内取得了优异的票房成绩，更在国际市场上赢得了广泛关注。从科幻巨制到现实主义题材，从动画电影到文艺佳作，国产电影的多元化发展令人欣喜。本文将为大家盘点2024年国产电影票房前十名，带你回顾这一年银幕上的精彩瞬间。排在首位的是《流浪地球3》，作为中国科幻电影的标杆之作，该片以震撼的视觉特效和宏大的叙事格局征服了观众。紧随其后的是《封神第二部》，以中国古典神话为蓝本，打造了一场视觉与情感的双重盛宴。此外，《热辣滚烫》凭借真实感人的故事和精湛的表演，成为年度黑马。",
  },
  {
    id: 2,
    title: "从《狂飙》到《繁花》：国产剧的黄金时代来了吗",
    category: "电视剧",
    author: "剧评人小张",
    date: "2024-11-28",
    imageUrl: "https://readdy.ai/api/search-image?query=Elegant%20living%20room%20scene%20with%20warm%20evening%20light%20and%20cozy%20atmosphere%2C%20television%20review%20concept%2C%20artistic%20composition%20with%20rich%20amber%20and%20soft%20golden%20tones%2C%20editorial%20cinematic%20style%2C%20clean%20design%2C%20no%20text&width=800&height=450&seq=article-02&orientation=landscape",
    slug: "golden-age-of-chinese-tv-dramas",
    summary: "近年国产电视剧质量大幅提升，从剧本到表演都达到了新高度，本文深度解析国产剧的崛起之路。",
    content: "近年来，国产电视剧市场呈现出前所未有的繁荣景象。从《狂飙》到《繁花》，从《庆余年2》到《大江大河3》，一部部优质剧集不断刷新着观众的期待。这些作品在剧本创作、导演技巧、演员表演等各个方面都达到了新的高度。特别是在现实主义题材方面，国产剧展现出了深刻的社会洞察力和人文关怀。《狂飙》通过一正一邪两条线索，深刻揭示了扫黑除恶的艰辛与必要。《繁花》则以九十年代上海为背景，描绘了一幅波澜壮阔的时代画卷。这些作品的成功，标志着国产剧正在进入一个真正的黄金时代。",
  },
  {
    id: 3,
    title: "综艺节目如何平衡娱乐性与社会价值",
    category: "综艺",
    author: "媒体研究員",
    date: "2024-11-10",
    imageUrl: "https://readdy.ai/api/search-image?query=Modern%20TV%20studio%20with%20warm%20professional%20lighting%20and%20creative%20atmosphere%2C%20media%20analysis%20concept%2C%20artistic%20composition%20with%20rich%20coral%20and%20golden%20tones%2C%20editorial%20style%2C%20clean%20design%2C%20no%20text&width=800&height=450&seq=article-03&orientation=landscape",
    slug: "variety-show-entertainment-social-value",
    summary: "在追求收视率的同时，综艺节目如何承担社会责任、传递正能量，成为行业热议话题。",
    content: "综艺节目作为大众娱乐的重要组成部分，在带给观众欢乐的同时，也承担着传递社会价值观的责任。近年来，《乘风破浪的姐姐》通过展现30+女性的自信与魅力，打破了年龄焦虑的刻板印象。《向往的生活》则通过回归田园的生活方式，传递了简单生活的美好理念。这些节目在保持娱乐性的同时，巧妙地融入了社会议题和人文关怀，让观众在轻松愉悦的氛围中收获思考。综艺节目的未来发展方向，应当是在娱乐性和社会价值之间找到最佳平衡点，既让观众开怀大笑，又能引发共鸣与反思。",
  },
  {
    id: 4,
    title: "国产动漫崛起：《哪吒》之后还有哪些惊喜",
    category: "动漫",
    author: "动漫爱好者",
    date: "2024-10-22",
    imageUrl: "https://readdy.ai/api/search-image?query=Artistic%20animation%20studio%20scene%20with%20warm%20creative%20lighting%20and%20colorful%20sketches%2C%20animation%20review%20concept%2C%20artistic%20composition%20with%20rich%20red%20and%20golden%20tones%2C%20cinematic%20editorial%20style%2C%20clean%20design%2C%20no%20text&width=800&height=450&seq=article-04&orientation=landscape",
    slug: "chinese-animation-rise-after-nezha",
    summary: "从《大圣归来》到《哪吒之魔童降世》，国产动漫正在经历前所未有的黄金发展期。",
    content: "国产动漫产业在过去几年中取得了令人瞩目的成就。2015年《大圣归来》以9.56亿票房开启了国漫复兴之路，2019年《哪吒之魔童降世》更是以50亿票房创造了动画电影的新纪录。如今，越来越多的优秀国产动漫作品正在涌现。从技术层面看，国产动漫的视觉效果已经达到了国际水准。从故事层面看，越来越多的作品开始深挖中国传统文化IP，用现代化的叙事手法讲述中国故事。2025年即将上映的《哪吒之魔童闹海》备受期待，预计将再次掀起国产动漫的观影热潮。",
  },
];

export const testimonials = [
  {
    id: 1,
    name: "张先生",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%20with%20warm%20lighting%2C%20friendly%20expression%2C%20clean%20studio%20background%2C%20professional%20headshot%20style&width=80&height=80&seq=avatar-01&orientation=squarish",
    content: "91麻豆免费视频网站资源太丰富了，各类国产影视作品都能找到，画质清晰流畅，是我每天必上的网站。",
    rating: 5,
  },
  {
    id: 2,
    name: "李女士",
    avatar: "https://readdy.ai/api/search-image?query=Elegant%20Chinese%20female%20portrait%20with%20warm%20soft%20lighting%2C%20gentle%20smile%2C%20clean%20studio%20background%2C%20professional%20headshot%20style&width=80&height=80&seq=avatar-02&orientation=squarish",
    content: "追剧党福音！更新速度很快，基本和电视台同步，而且没有乱七八糟的广告打扰，体验感很好。",
    rating: 5,
  },
  {
    id: 3,
    name: "王同学",
    avatar: "https://readdy.ai/api/search-image?query=Young%20Chinese%20male%20student%20portrait%20with%20warm%20natural%20lighting%2C%20friendly%20smile%2C%20clean%20studio%20background%2C%20casual%20professional%20headshot%20style&width=80&height=80&seq=avatar-03&orientation=squarish",
    content: "分类很清晰，找片子很方便。91年国产影片视频频道是我最喜欢的，经典老片也能找到，太赞了！",
    rating: 4,
  },
];

export const aboutInfo = {
  brandName: "91麻豆免费视频网站",
  description: "91麻豆免费视频网站是国内领先的综合性影视在线观看平台，致力于为观众提供丰富、优质、便捷的在线视频服务。平台集合91年国产影片视频、91传媒视频在线、91精彩视频在线观看等多个特色频道，涵盖电影、电视剧、综艺、动漫、纪录片等全品类内容。",
  mission: "让每一位观众都能轻松找到喜爱的影视内容，享受高品质的在线观看体验。",
  founded: "2019年",
  users: "超过500万",
  contentCount: "10000+",
  dailyUpdate: "100+",
  contactEmail: "contact@91madou.com",
  contactPhone: "400-888-9191",
  address: "北京市朝阳区建国路88号SOHO现代城A座",
};